import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Isvg from 'react-inlinesvg';
import LocaleText from '../../LocaleText';

class Texts extends React.Component {
    renderText(text) {
        const isActive = _.isEqual(this.props.activeText, text.id);
        const classes = ['menu__item'];
        let key = `text-${text.id}`;

        if (isActive) {
            classes.push('menu__item--active');
        }

        const style = {
            fontWeight: text.bold ? 'bold' : 'normal',
            fontStyle: text.italic ? 'italic' : 'initial',
            textAlign: text.alignment,
            fontFamily: text.font,
            color: `rgb(${text.color.r},${text.color.g},${text.color.b})`,
        };

        return (
            <li
                className={classes.join(' ')}
                key={key}
                onClick={() => this.props.onTextSelect(text)}
            >
                <div className="text">
                    <span className="text__value" style={style}>
                        {text.text}
                    </span>
                    {/*<div className="text__control text__controls--remove"*/}
                    {/*onClick={() => this.props.onTextRemove(text.id)}>*/}
                    {/*<Isvg src="/svg/cancel.svg"/>*/}
                    {/*</div>*/}
                    {/*<div className="text__control text__controls--edit"*/}
                    {/*onClick={() => this.props.onTextEdit(text.id)}>*/}
                    {/*<Isvg src="/svg/edit.svg"/>*/}
                    {/*</div>*/}
                </div>
            </li>
        );
    }

    render() {
        const { texts, onAddNewText } = this.props;
        return (
            <div className="submenu__row text-selection">
                <ul className="menu">
                    <li className="menu__item" onClick={onAddNewText}>
                        <span className="label">
                            <LocaleText textKey="configurator.add.custom.text" />
                        </span>
                    </li>
                    {texts.map(text => this.renderText(text))}
                </ul>
            </div>
        );
    }
}

Texts.propTypes = {
    activeText: PropTypes.number,
    onAddNewText: PropTypes.func.isRequired,
    onTextSelect: PropTypes.func.isRequired,
    // onTextRemove: PropTypes.func.isRequired,
    // onTextEdit: PropTypes.func.isRequired,
};

Texts.defaultProps = {
    activeText: null,
};

export default Texts;
